import * as React from "react";
import {
   BrandRuleTradeInSearchAmountsExpressionsInput,
   DtcEditBrandRuleFragment,
   EnumBrandRuleTradeInSearchAmountsExpressionsOperation,
   EnumBrandRuleTradeInSearchAmountsExpressionsValueType,
   useProductEditorBrandByIdQuery
} from "../../../../../Queries";
import {useFieldArray, useFormContext} from "react-hook-form";
import FormInputAutocomplete2 from "../../../wholesale/form/FormInputAutocomplete2";
import {Box, Grid, IconButton, LinearProgress} from "@mui/material";
import {MenuExpressionTypes} from "./MenuExpressionType";
import {FormInputSelect} from "../../../wholesale/form/FormInputSelect";
import {DeleteForever} from "@mui/icons-material";
import {FormInputText} from "../../../wholesale/form/FormInputText";

export const ProductEditor = (props: { shopId: string, name?: string }) => {
   const fieldName = props.name || 'expressions';

   const {data} = useProductEditorBrandByIdQuery({
      variables: {
         shopId: props.shopId
      }
   });

   const form = useFormContext<DtcEditBrandRuleFragment>();
   const {getValues} = form;

   const {fields, append, remove} = useFieldArray<DtcEditBrandRuleFragment>({
      name: fieldName as 'expressions'
   })

   if (!data?.ShopById) {
      return <LinearProgress/>
   }

   const options = {
      TAG: (data?.ShopById?.productTags || []),
      COLLECTION: (data?.ShopById?.productCollections || []),
      VENDOR: (data?.ShopById?.productVendors || []),
      TYPE: (data?.ShopById?.productTypes || []),
      METAFIELD: [],
      EAN: [],
      SKU: [],
      NAME: []
   }

   return <Box sx={{width: '100%'}}>
      {fields.map((field, index) => {
         const expr = getValues(`${fieldName}.${index}.valueType` as `expressions.${number}.valueType`)

         return <Grid spacing={"4px"} container key={field.id}>
            <Grid item xs={2}>
               <FormInputSelect disabled={true} name={`${fieldName}[${index}].valueType`} label={"Product"}
                                options={Object.values(EnumBrandRuleTradeInSearchAmountsExpressionsValueType).map(valueType => ({
                                   id: valueType,
                                   name: valueType
                                }))}/>
            </Grid>
            <Grid item xs={1}>
               <FormInputText name={`${fieldName}[${index}].key`} label={"Key (metafield)"}/>
            </Grid>
            <Grid item xs={2}>
               <FormInputSelect name={`${fieldName}[${index}].operation`} label={"Must"}
                                options={Object.values(EnumBrandRuleTradeInSearchAmountsExpressionsOperation).map(valueType => ({
                                   id: valueType,
                                   name: valueType
                                }))}/>
            </Grid>
            <Grid item xs={5}>
               <FormInputAutocomplete2
                  fullWidth
                  options={options[expr]}
                  name={`${fieldName}[${index}].value`}
                  label={"Any of:"}
               />
            </Grid>
            <Grid item xs={1}>
               <IconButton onClick={() => remove(index)}>
                  <DeleteForever/>
               </IconButton>
            </Grid>
         </Grid>
      })}
      <MenuExpressionTypes onSelect={(type) => {
         append({
            value: [],
            operation: EnumBrandRuleTradeInSearchAmountsExpressionsOperation.INCLUDE,
            valueType: type
         } as BrandRuleTradeInSearchAmountsExpressionsInput);
      }}/>
   </Box>
}
